export default "__VITE_PUBLIC_ASSET__9a4d0dd0__"